
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { DummyComponent } from '../../shared/dummy.component';
import { consts } from '../../consts';
import { Utils } from '../../shared/utils';
import { AdvisorModel } from './advisor.model';
import { AdvisorService } from './advisor.service';
import { AdvisorListComponent } from './advisor-list.component';
import { MunicipalityService } from '../../services/data/municipality.service';
import { ProvinceService } from '../../services/data/province.service';

@Component({
    selector: 'app-advisor-form',
    templateUrl: './advisor-form.component.html',
    styleUrls: ['./advisor-form.component.css'],
    standalone: false
})
export class AdvisorFormComponent implements OnInit {
  ready = false;
  uid: number = this.data.uid;
  model: AdvisorModel;

  public provinces: any[] = [];
  public municipalities: any[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dummy: DummyComponent,
    public advisorService: AdvisorService,
    public dialogRef: MatDialogRef<AdvisorListComponent>,
    public snackBar: MatSnackBar,
    private provinceService: ProvinceService,
    private municipalityService: MunicipalityService
  ) {
    this.model = new AdvisorModel();
  }

  ngOnInit() {
    this.loadProvinces();

    if (this.uid !== null && this.uid != undefined) {
      this.advisorService.loadData(this.uid).then(response => {
        this.model = response;
        this.ready = true;
      });
    } else {
      this.ready = true;
    }

  }

  public loadProvinces() {
    this.provinceService.getList().subscribe(response => {
      this.provinces = response.data;
    });
  }

  public onChangeProvince() {
    if (this.model.provinceCode != null && this.model.provinceCode != '')
      this.municipalityService.getList({ province_code: this.model.provinceCode }).subscribe(response => {
        this.municipalities = response.data;
      });
    else
      this.municipalities = [];
  }

  onProvinceChanged(provinceId: number) {
    this.onChangeProvince();
  }

  // SAVE
  public onSubmit() {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.save();
  }

  public save() {
    if (this.model.uid == null || this.model.uid == '') {
      this.advisorService.addData(this.model)
        .then(res => {
          this.dummy.redirectTo('/admin/advisors');
        },
          error => this.displayInfo(error.error['message'])
        )
    } else {
      this.advisorService.editData(this.model.uid, this.model)
        .then(res => {
          this.dummy.redirectTo('/admin/advisors');
        },
          error => this.displayInfo(error.error['message'])
        )
    }
    this.dialogRef.close(true);
  }

  closeDialog() {
    this.dialogRef.close(true);
  }

  displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container'];
    this.snackBar.open(message, '', options);
  }
}

